import * as React from 'react'

const ArrowCircleDown = ({
  title,
  titleId,
  ...props
}: {
  title?: string
  titleId?: string
} & React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#400099"
    focusable={false}
    aria-hidden
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M12 21.75c-5.385 0-9.75-4.365-9.75-9.75S6.615 2.25 12 2.25s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75zm0-1.5a8.25 8.25 0 100-16.5 8.25 8.25 0 000 16.5zm.53-4.78a.75.75 0 11-1.06 1.06l-4-4.006a.75.75 0 010-1.061l4-3.994a.75.75 0 011.06 1.062l-3.47 3.464 3.47 3.475zm-4.46-2.72a.75.75 0 110-1.5h8.062a.75.75 0 110 1.5H8.07z" />
  </svg>
)

export default ArrowCircleDown
